import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * FormDialog - Reusable dialog wrapper for form-based dialogs
 * @param {boolean} open - Whether the dialog is open
 * @param {string} title - Dialog title
 * @param {React.ReactNode} children - Dialog content (form fields)
 * @param {Function} onClose - Callback when dialog is closed
 * @param {Function} onConfirm - Callback when primary action is confirmed
 * @param {string} confirmLabel - Label for confirm button (default: 'Save')
 * @param {string} cancelLabel - Label for cancel button (default: 'Cancel')
 * @param {boolean} loading - Whether an operation is in progress
 * @param {boolean} confirmDisabled - Whether confirm button should be disabled
 */
export default function FormDialog({
  open,
  title,
  children,
  onClose,
  onConfirm,
  confirmLabel = 'Save',
  cancelLabel = 'Cancel',
  loading = false,
  confirmDisabled = false
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading || confirmDisabled}
          variant="contained"
        >
          {loading ? <CircularProgress size={24} /> : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
